import { registerPropertyManagerSection } from '@/core';
import LinearComponentPatternPropertySection from '@/components/editor/property-manager/linear-component-pattern/LinearComponentPatternPropertySection.vue';

/**
 * 注册“线性零部件阵列”属性面板。
 *
 * 设计说明：
 * 1. 该命令属于装配体零部件阵列，不复用零件特征线性阵列 PropertyManager；
 * 2. 当前只提供 UI 与命令会话壳，后续由 cad-core 控制器承接求解与提交；
 * 3. 确认和取消通过宿主上下文回调收口，避免注册表直接依赖 Editor 层状态。
 */
registerPropertyManagerSection({
  id: 'assembly-linear-component-pattern',
  title: '线性阵列',
  order: 51,
  component: LinearComponentPatternPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => context.activeCommand === 'assembly-linear-component-pattern',
  onConfirm: (context) => {
    context.confirmAssemblyLinearComponentPattern?.();
  },
  onCancel: (context) => {
    context.cancelAssemblyLinearComponentPattern?.();
  },
  onHelp: () => {
    window.open(
      'https://help.solidworks.com/2026/chinese-simplified/SolidWorks/sldworks/r_linear_component_pattern_pm.htm?id=6.1.8.9',
      '_blank',
      'noopener,noreferrer',
    );
  },
});
